import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// Initialize dayjs with timezone support
dayjs.extend(utc);
dayjs.extend(timezone);

export { dayjs };
